import moment from "moment";
import authActionTypes from "containers/Auth/_actions";
import actionTypes from "./_actions";

const INITIAL_STATE = [];

const farmsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.REQUEST_PAYMENT_SUCCESS: {
            const { paymentTransaction, farm = {} } = action.payload;
            const offlineFarm = state.find((f) => f.id === farm.id);
            if (!offlineFarm) return state;
            offlineFarm.paymentTransaction = paymentTransaction;
            return [...state.filter((f) => f.id !== farm.id), ...[offlineFarm]];
        }
        case actionTypes.REQUEST_PAYMENT_STATUS_SUCCESS: {
            const { paymentTransaction, farm = {} } = action.payload;
            const offlineFarm = state.find((f) => f.id === farm.id);
            if (!offlineFarm) return state;
            offlineFarm.paymentTransactionStatus = paymentTransaction;
            return [...state.filter((f) => f.id !== farm.id), ...[offlineFarm]];
        }
        case actionTypes.PAYMENT_CLEAR: {
            const offlineFarm = state.find((f) => f.id === action.payload);
            if (!offlineFarm) return state;
            delete offlineFarm.paymentTransaction;
            delete offlineFarm.paymentTransactionStatus;
            return [...state.filter((f) => f.id !== action.payload), ...[offlineFarm]];
        }
        case actionTypes.FARM_TOUCHED: {
            const { farm, isNew } = action.payload;

            const offlineFarm1 = {
                id: farm.id,
                isDirty: true,
                farm,
                isNew,
            };

            const offlineFarms1 = state.map((f) => {
                if (f.id === offlineFarm1.id) return offlineFarm1;

                return f;
            });

            if (!offlineFarms1.some((f) => f.id === offlineFarm1.id)) offlineFarms1.push(offlineFarm1);

            return offlineFarms1;
        }
        case actionTypes.TOGGLE_PAYMENT_NOTIFICATION: {
            const { farmId, accountId } = action.payload;
            const offlineFarmWithPaymentChanged = state.find((f) => f.id === farmId);
            if (!offlineFarmWithPaymentChanged || !offlineFarmWithPaymentChanged.farm) return state;
            const { access = [] } = offlineFarmWithPaymentChanged.farm;
            const accountAccess = access.find((a) => a.accountId === accountId);
            if (!accountAccess) return;

            return state.map((offlineFarm) => {
                if (offlineFarm.id !== farmId) return offlineFarm;

                const updatedOf = {
                    ...offlineFarm,
                    farm: {
                        ...offlineFarm.farm,
                        access: [...access.filter((a) => a.accountId !== accountId), { ...accountAccess, paymentNotification: !accountAccess.paymentNotification }],
                    },
                };
                return updatedOf;
            });
        }

        case actionTypes.FARM_SAVED: {
            return state.map((f) => {
                if (f.id === action.payload)
                    return {
                        ...f,
                        isDirty: false,
                        isNew: false,
                    };

                return f;
            });
        }

        case actionTypes.FARM_SAVE_ERROR: {
            const { farm, error } = action.payload;

            return state.map((offlineFarm) => {
                if (offlineFarm.id !== farm.id) return offlineFarm;

                return {
                    ...offlineFarm,
                    error: {
                        requestId: (error.xhr.response || {}).requestId,
                        status: error.status,
                        message: error.message,
                    },
                };
            });
        }

        case actionTypes.FARM_FETCHING: {
            const { id } = action.payload;

            return state.map((offlineFarm) => {
                if (offlineFarm.id === id)
                    return {
                        ...offlineFarm,
                        isLoading: true,
                    };

                return offlineFarm;
            });
        }

        case actionTypes.FARM_FETCHED: {
            const fetchedFarm = {
                ...action.payload,
                offlineBudgets: action.payload.budgets.map((budget) => ({
                    id: budget.id,
                    farmId: budget.farmId,
                    versionId: budget.versionId,
                    isNew: false,
                    isDirty: false,
                    lastFetchedTimestamp: moment().valueOf(),
                    budget,
                })),
            };

            delete fetchedFarm.budgets;

            //Retain the access, invitations & requests by merging the existing farm
            const stateFarm = state.find((f) => f.id === fetchedFarm.id) || {};
            if (stateFarm.farm) {
                fetchedFarm.access = stateFarm.farm.access;
                fetchedFarm.accessInvitations = stateFarm.farm.accessInvitations;
                fetchedFarm.accessRequests = stateFarm.farm.accessRequests;
            }

            const fetched = {
                id: fetchedFarm.id,
                isLoading: false,
                isDirty: false,
                isNew: false,
                lastFetchedTimestamp: moment().valueOf(),
                farm: fetchedFarm,
            };

            const offlineFarms2 = state.map((offlineFarm) => {
                if (offlineFarm.id !== fetched.id) return offlineFarm;

                // Merge offline budgets.
                let offlineBudgets = fetched.farm.offlineBudgets.map((newOfflineBudget) => {
                    // Do not overwrite dirty or downloaded budgets that haven't changed.
                    const oldOfflineBudget = (offlineFarm.farm.offlineBudgets || []).find((ob) => ob.id === newOfflineBudget.id);
                    if (oldOfflineBudget && (oldOfflineBudget.isDirty || (oldOfflineBudget.versionId === newOfflineBudget.versionId && oldOfflineBudget.budget.nLossPerHa === newOfflineBudget.budget.nLossPerHa))) {
                        return {
                            ...oldOfflineBudget,
                            budget: {
                                ...oldOfflineBudget.budget,
                            },
                        };
                    }

                    return newOfflineBudget;
                });
                offlineBudgets = offlineBudgets.concat((offlineFarm.farm.offlineBudgets || []).filter((ob) => ob.isNew));

                if (offlineFarm.isDirty) {
                    return {
                        ...offlineFarm,
                        isLoading: false,
                        farm: {
                            ...offlineFarm.farm,
                            offlineBudgets,
                        },
                    };
                }

                return {
                    ...fetched,
                    farm: {
                        ...fetched.farm,
                        offlineBudgets,
                    },
                };
            });
            if (!offlineFarms2.some((f) => f.id === fetched.id)) offlineFarms2.push(fetched);

            return offlineFarms2;
        }

        case actionTypes.FARM_ACCESS_FETCHED: {
            const { id, access, accessRequests, accessInvitations } = action.payload;

            return state.map((f) => {
                if (f.id === id)
                    return {
                        ...f,
                        isLoading: false,
                        farm: {
                            ...f.farm,
                            access,
                            accessRequests,
                            accessInvitations,
                        },
                    };

                return f;
            });
        }

        case actionTypes.FARM_CLEAR_STALE: {
            return state.filter((f) => !f.lastFetchedTimestamp || moment.utc(f.lastFetchedTimestamp) > action.payload);
        }

        case actionTypes.FARM_NOT_FOUND: {
            const offlineFarm2 = {
                id: action.payload,
                isLoading: false,
                notFound: true,
            };

            const offlineFarms3 = state.map((f) => {
                if (f.id === offlineFarm2.id) return offlineFarm2;

                return f;
            });

            if (!offlineFarms3.some((f) => f.id === offlineFarm2.id)) offlineFarms3.push(offlineFarm2);

            return offlineFarms3;
        }

        case actionTypes.FARM_ACCESS_DENIED: {
            const farm = {
                ...action.payload,
            };

            const offlineFarm3 = {
                id: farm.id,
                accessDenied: true,
                isLoading: false,
                farm,
            };

            const offlineFarms4 = state.map((f) => {
                if (f.id === offlineFarm3.id) return offlineFarm3;

                return f;
            });

            if (!offlineFarms4.some((f) => f.id === offlineFarm3.id)) offlineFarms4.push(offlineFarm3);

            return offlineFarms4;
        }

        case actionTypes.TOGGLE_MY_FARM_SUCCESS: {
            const offlineFarms = state.map((offlineFarm) => {
                if (offlineFarm.id === action.payload.id)
                    return {
                        ...offlineFarm,
                        farm: {
                            ...offlineFarm.farm,
                            isMyFarm: action.payload.isMyFarm,
                        },
                    };

                return offlineFarm;
            });
            return offlineFarms;
        }

        case authActionTypes.AUTH_CLEAR_STORAGE:
            return INITIAL_STATE;

        default:
            return state;
    }
};
export default farmsReducer;
